export enum Theme {
  LightTheme = 'light',
  DarkTheme = 'dark'
}
export interface LayoutState {
  theme: Theme;
}
